export default "__VITE_ASSET__a4a9d9e8__"